import { ReviewItem as ReviewProps } from '@silvertours/common-landingpages-view';
import { UiLegacy } from '@silvertours/front-legacy-shared';

import {
  ReviewContainer,
  ReviewFooter,
  QuoteContainer,
  ColoredText,
} from './Reviews.styles';
import { ReviewHeader } from './ReviewHeader';
import { useReviewItem } from './useReviewItem';

const LargeReviewItem = (props: ReviewProps) => {
  const { providerQuote, siteQuote } = props;
  const {
    header,
    providersQuoteTitleLabel,
    reviewerLabel,
    siteQuoteTitleLabel,
  } = useReviewItem(props);

  return (
    <ReviewContainer largeReview>
      <ReviewHeader {...header} />
      <QuoteContainer>
        <UiLegacy.PlainText>
          <ColoredText>{siteQuoteTitleLabel}</ColoredText>
        </UiLegacy.PlainText>
        <UiLegacy.Quote>{siteQuote}</UiLegacy.Quote>
        <UiLegacy.PlainText>
          <ColoredText>{providersQuoteTitleLabel}</ColoredText>
        </UiLegacy.PlainText>
        <UiLegacy.Quote>{providerQuote.quote}</UiLegacy.Quote>
      </QuoteContainer>

      <ReviewFooter>
        <UiLegacy.PlainText>{reviewerLabel}</UiLegacy.PlainText>
      </ReviewFooter>
    </ReviewContainer>
  );
};

export { LargeReviewItem };
